import Hello from './Hello.vue'

/* istanbul ignore next */
Hello.install = function (app) {
  app.component(Hello.name, Hello)
}

export default Hello


//////////////////
// WEBPACK FOOTER
// ./packages/hello/index.js
// module id = null
// module chunks = 